export default "__VITE_ASSET__2250dccf__"